import React from 'react'
import styled from 'styled-components';
import ActivityItem from 'components/commons/ActivityItem';
import BlockTopBar from 'components/commons/BlockTopBar';
import GlobalStyle from 'stylecomponents/globalstyle';
import PropTypes from 'prop-types';

const SmallBlockContainer = GlobalStyle.BasicBlock.extend`
  min-height: 250px;
  &:first-child {
    margin-right: ${GlobalStyle.ViewSpace}px;
  }
`;
const List = styled.div`
`;

const SmallBlock = props => {

  const {
    title,
    data,
    stateName,
    isError,
    bclass,
  } = props;

  return (
    <SmallBlockContainer>
      <BlockTopBar
        title={title}
        state={stateName}
        bclass={bclass}
      />
      <List>
        {data.map(d => {

          const {
            bulletinid,
            title = '',
            publishtime,
            topbulletin,
          } = d;

          return (
            <ActivityItem
              key={bulletinid}
              title={title.trim()}
              time={publishtime}
              stateName={stateName}
              bulletinid={bulletinid}
              topbulletin={topbulletin}
            />
          );
        })}
      </List>
      {isError && (
        <GlobalStyle.ErrorContainer>
            <GlobalStyle.ErrorContainerTitle>
                發生錯誤
            </GlobalStyle.ErrorContainerTitle>
            <GlobalStyle.ErrorContainerDesription>
                無法取得列表，請重新整理後再嘗試。
            </GlobalStyle.ErrorContainerDesription>
        </GlobalStyle.ErrorContainer>
      )}
    </SmallBlockContainer>
  );
};

SmallBlock.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  stateName: PropTypes.string,
  isError: PropTypes.bool,
};

export default SmallBlock;
